import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'filter.other.title',
    defaultMessage: 'Autres',
  },
  certifiedTitle: {
    id: 'filter.other.certified.title',
    defaultMessage: 'Sherpas certifiés <icon></icon>',
  },
  certifiedContent: {
    id: 'filter.other.certified.content',
    defaultMessage: 'Prenez des cours avec un Sherpa reconnu.',
  },
  certifiedLink: {
    id: 'filter.other.certified.link',
    defaultMessage: 'En savoir plus',
  },
  answerFastTitle: {
    id: 'filter.other.answer.title',
    defaultMessage: 'Réponse rapide <icon></icon>',
  },
  answerFastContent: {
    id: 'filter.other.answer.content',
    defaultMessage: 'Voir seulement les professeurs répondant sous 24h.',
  },
  availableTitle: {
    id: 'filter.other.available.title',
    defaultMessage: 'Disponible <icon></icon>',
  },
  availableContent: {
    id: 'filter.other.available.content',
    defaultMessage: 'Disponibilité confirmée depuis moins de 2 semaines.',
  },
});
